import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import CreditCardForm from '../forms/creditCardForm/CreditCardForm'
import SSLBadge from '../../assets/images/ssl-badge-blue.png'

class BkFlowPaymentCreditCard extends Component {

	constructor(props) {
		super(props)
		this.state = {
		}
	}

	render() {
		const {
			activeCreditCardType,
			availabilityData,
			configData,
			urlData
		} = this.props
		const hotelLabels = configData.hotel.labels[0]

		let baseClassNames = 'bk-flow-payment__credit-card u-form-card default'

		if (process.env.REACT_APP_COMPONENT_PAYMENT_FORMS_LAYOUT) {
			baseClassNames = 'bk-flow-payment__credit-card u-form-card ' + process.env.REACT_APP_COMPONENT_PAYMENT_FORMS_LAYOUT
		}

		return (
			<div className={baseClassNames}>
				<h3 className="bk-flow-payment__credit-card-heading">
					<span className="bk-flow-payment__credit-card-heading-label">{ hotelLabels.paymentInformation }</span>
					<div className="bk-flow-payment__credit-card-ssl">
						<p><i className="material-icons">lock</i> { hotelLabels.securePaymentMessage }</p>
						<img src={ SSLBadge } alt="SSL Trust" width="103" height="20" />
					</div>
				</h3>

				<CreditCardForm
					activeCreditCardType={activeCreditCardType}
					availabilityData={availabilityData}
					configData={configData}
					form="paymentForm"
					urlData={urlData}
				/>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		activeCreditCardType: state.activeCreditData.creditType,
		availabilityData: state.availabilityData.availability,
		configData: state.configData.configuration,
		urlData: state.availabilityData.urlData,
	}
}

//connects redux actions to props
function mapDispatchToProps(dispatch) {
	return bindActionCreators({
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BkFlowPaymentCreditCard)


// WEBPACK FOOTER //
// ./src/components/payment/BkFlowPaymentCreditCard.js